import React, { useEffect, useState, useCallback } from "react";
import { Table, Tag, Typography, Input, Space, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import { privateAdminGetApi } from "../../utils/apiHelper";

const { Title, Text, Paragraph } = Typography;

const METHOD_COLORS = {
  POST: "green",
  PUT: "blue",
  DELETE: "red",
};

function renderDiff(value) {
  if (value == null) return "-";
  return (
    <pre style={{ margin: 0, fontSize: 12, whiteSpace: "pre-wrap" }}>
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}

export default function AdminActivityLog() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adminEmail, setAdminEmail] = useState("");

  const fetchLogs = useCallback(() => {
    setLoading(true);
    const query = {};
    if (adminEmail.trim()) query.adminEmail = adminEmail.trim();
    privateAdminGetApi("admin/activity-log", query)
      .then((res) => {
        setRecords(res.data.result.records);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [adminEmail]);

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (v) => new Date(v).toLocaleString(),
      width: 190,
    },
    { title: "Admin", dataIndex: "adminEmail", key: "adminEmail" },
    {
      title: "Action",
      dataIndex: "method",
      key: "method",
      render: (v) => <Tag color={METHOD_COLORS[v] || "default"}>{v}</Tag>,
    },
    { title: "URL", dataIndex: "url", key: "url", ellipsis: true },
    { title: "Resource ID", dataIndex: "resourceId", key: "resourceId" },
    {
      title: "Before",
      dataIndex: "before",
      key: "before",
      render: renderDiff,
    },
    {
      title: "After",
      dataIndex: "after",
      key: "after",
      render: renderDiff,
    },
  ];

  return (
    <div>
      <Space
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Title level={5} style={{ marginBottom: 0 }}>
          Admin activity log
        </Title>
        <Space>
          <Input
            allowClear
            placeholder="Filter by admin email"
            style={{ width: 240 }}
            value={adminEmail}
            onChange={(e) => setAdminEmail(e.target.value)}
            onPressEnter={fetchLogs}
          />
          <Button icon={<ReloadOutlined />} onClick={fetchLogs} />
        </Space>
      </Space>
      <Paragraph type="secondary" style={{ marginBottom: 8 }}>
        Every create/update/delete action taken by an admin account, with a
        before/after diff where the route recorded one.
      </Paragraph>
      {!records.length && !loading ? (
        <Text type="secondary">No admin mutations recorded yet.</Text>
      ) : (
        <Table
          rowKey="_id"
          loading={loading}
          columns={columns}
          dataSource={records}
          pagination={{ pageSize: 50 }}
          scroll={{ x: 1100 }}
        />
      )}
    </div>
  );
}
